import type { DownloadHistoryItem } from '../../domain/entities/Order';
import type { OrderRepository } from '../../domain/repositories/OrderRepository';

export class GetDownloadHistoryUseCase {
  constructor(private readonly repository: OrderRepository) {}

  async execute(): Promise<DownloadHistoryItem[]> {
    return this.repository.getDownloadHistory();
  }
}
